function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "81",
  viewBox: "0 0 82 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1956_114200)"
}, /*#__PURE__*/React.createElement("rect", {
  x: "1",
  y: "1.5",
  width: "80",
  height: "17",
  rx: "1",
  fill: "#FAFAFA"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFC857",
  d: "M1 1.5h19v17H1z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.5 15.175a4.675 4.675 0 100-9.35 4.675 4.675 0 000 9.35zm0 .825a5.5 5.5 0 100-11 5.5 5.5 0 000 11z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.11 12.965a.496.496 0 01-.158-.373.53.53 0 01.538-.525.55.55 0 01.39.152.485.485 0 01.162.373c0 .15-.054.275-.162.373a.556.556 0 01-.39.148.536.536 0 01-.38-.148zm-.104-4.664h.985l-.13 3.36h-.724l-.131-3.36z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: "24",
  y: "8",
  width: "48",
  height: "4",
  rx: "2",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.55 8.653a.346.346 0 11.49.49l-2.204 2.202a.346.346 0 11-.49-.49l2.203-2.202z",
  fill: "#D2D6DB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.038 10.857a.346.346 0 11-.49.49l-2.202-2.204a.346.346 0 01.49-.49l2.202 2.204z",
  fill: "#D2D6DB"
})), /*#__PURE__*/React.createElement("rect", {
  x: ".5",
  y: "1",
  width: "81",
  height: "18",
  rx: "1.5",
  stroke: "#DDE0E4"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1956_114200"
}, /*#__PURE__*/React.createElement("rect", {
  x: "1",
  y: "1.5",
  width: "80",
  height: "17",
  rx: "1",
  fill: "#fff"
})))));